import '../styles.css';

function Projects() {
  return (
    <section id="projects" className="section projects-section">
      
      <div className="section-container">

        <div className="section-header">
          <span className="section-number">04</span>

          <h2 className="section-title">
            <span className="title-bracket">&lt;</span>
            <span
              className="title-text"
              data-text-en="Projects"
              data-text-ar="المشاريع"
            >
              Projects
            </span>
            <span className="title-bracket">/&gt;</span>
          </h2>

          <div className="section-line"></div>
        </div>

        <div className="projects-grid">

          {/* Project 1 */}
          <div className="project-card">
            <div className="project-image">
              <img src="ziauddinboardadmission.com.png" alt="Ziauddin Board Admission" />

              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://ziauddinboardadmission.com/" className="project-link" title="View Project">
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                  <a href="#" className="project-link" title="View Code">
                    <i className="fab fa-github"></i>
                  </a>
                </div>
              </div>

              <div className="project-placeholder">
                <i className="fas fa-shopping-cart"></i>
              </div>
            </div>

            <div className="project-content">
              <h3 className="project-title">Ziauddin Board Admission</h3>

              <p className="project-description">
                A complete admission portal built with WordPress and Elementor Pro,
                featuring dynamic forms, responsive design, and optimized performance.
              </p>

              <div className="project-tags">
                <span className="tag">WordPress</span>
                <span className="tag">Elementor Pro</span>
                <span className="tag">PHP</span>
              </div>
            </div>
          </div>

          {/* Project 2 */}
          <div className="project-card">
            <div className="project-image">
              <img src="Samadev-Solutions .png" alt="Samadev Solutions" />

              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://samadevsolutions.netlify.app/" className="project-link" title="View Project">
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                  <a href="#" className="project-link" title="View Code">
                    <i className="fab fa-github"></i>
                  </a>
                </div>
              </div>

              <div className="project-placeholder">
                <i className="fas fa-blog"></i>
              </div>
            </div>

            <div className="project-content">
              <h3 className="project-title">Samadev Solutions</h3>

              <p className="project-description">
                A startup website developed from scratch using HTML, CSS, and JavaScript
                to showcase company services, portfolio, and contact features with a
                responsive modern design.
              </p>

              <div className="project-tags">
                <span className="tag">HTML</span>
                <span className="tag">CSS</span>
                <span className="tag">JavaScript</span>
              </div>
            </div>
          </div>

          {/* Project 3 */}
          <div className="project-card">
            <div className="project-image">
              <img src="getvininfo.png" alt="GetVinInfo" />

              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://getvininfo.site/" className="project-link" title="View Project">
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                  <a href="#" className="project-link" title="View Code">
                    <i className="fab fa-github"></i>
                  </a>
                </div>
              </div>

              <div className="project-placeholder">
                <i className="fas fa-shopping-cart"></i>
              </div>
            </div>

            <div className="project-content">
              <h3 className="project-title">GetVinInfo</h3>

              <p className="project-description">
                A client-based WordPress website that provides VIN decoding and
                vehicle history verification. Built with Elementor, WooCommerce,
                and PayPal integration to deliver secure payments and a responsive,
                user-friendly automotive platform.
              </p>

              <div className="project-tags">
                <span className="tag">WordPress</span>
                <span className="tag">Elementor Pro</span>
                <span className="tag">PHP</span>
              </div>
            </div>
          </div>

          {/* Project 4 */}
          <div className="project-card">
            <div className="project-image">
              <img src="time galleria.png" alt="Time Galleria" />

              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://timegalleria.com/" className="project-link" title="View Project">
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                  <a href="#" className="project-link" title="View Code">
                    <i className="fab fa-github"></i>
                  </a>
                </div>
              </div>

              <div className="project-placeholder">
                <i className="fas fa-shopping-cart"></i>
              </div>
            </div>

            <div className="project-content">
              <h3 className="project-title">Time Galleria</h3>

              <p className="project-description">
                A luxury watch eCommerce website developed using WordPress,
                Elementor, and WooCommerce, featuring a refined UI, responsive
                layout, and optimized product browsing and checkout experience.
              </p>

              <div className="project-tags">
                <span className="tag">WordPress</span>
                <span className="tag">Elementor Pro</span>
                <span className="tag">PHP</span>
              </div>
            </div>
          </div>

          {/* Project 5 */}
          <div className="project-card">
            <div className="project-image">
              <img src="blooming petals.png" alt="Blooming Petals" />

              <div className="project-overlay">
                <div className="project-links">
                  <a href="https://samadtariq.github.io/Blooming-Petals/" className="project-link" title="View Project">
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                  <a href="#" className="project-link" title="View Code">
                    <i className="fab fa-github"></i>
                  </a>
                </div>
              </div>

              <div className="project-placeholder">
                <i className="fas fa-shopping-cart"></i>
              </div>
            </div>

            <div className="project-content">
              <h3 className="project-title">Blooming Petals</h3>

              <p className="project-description">
                A decorative flower and event-themed website developed as a
                first-semester team project using HTML, CSS, and JavaScript,
                featuring interactive UI components and basic eCommerce functionality.
              </p>

              <div className="project-tags">
                <span className="tag">HTML</span>
                <span className="tag">CSS</span>
                <span className="tag">JavaScript</span>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Projects;